export const objectUrlToFile = async(objectUrl, baseFileName) => {
  const response = await fetch(objectUrl);
  const blob = await response.blob();
  const mimeType = blob.type;
  const extension = mimeType.split("/")[1];
  const fileName = `${baseFileName}.${extension}`;
  return new File([blob], fileName, { type: mimeType });
};
